import * as Yup from "yup";
import { numberOnlyMask } from "@volca/ui/masks";
import { UpdateAddressParams } from "@/core/types/address";

export interface FormValues {
  service_needed: string;
  address: UpdateAddressParams;
  additional_info: string;
  service_titan_job_id: string;
  appointment_date: string | null;
}

export const serviceTitanJobIdMaskOptions = numberOnlyMask();

export const validationSchema = Yup.object().shape({
  service_needed: Yup.string(),
  service_titan_job_id: Yup.string(),
  address: Yup.object()
    .shape({
      line_one: Yup.string(),
      line_two: Yup.string(),
      city: Yup.string(),
      state: Yup.string(),
      zip_code: Yup.string(),
    })
    .test(
      "all-or-none",
      "Please complete all address fields (Address, City, State, and ZIP) or leave them all empty",
      (value) => {
        if (!value) return true;
        const fields: (keyof typeof value)[] = [
          "line_one",
          "city",
          "state",
          "zip_code",
        ];
        const filledFields = fields.filter((f) => value[f]);
        return (
          filledFields.length === 0 || filledFields.length === fields.length
        );
      },
    ),
  additional_info: Yup.string(),
  appointment_date: Yup.date().nullable(),
});
